<template>
    <div class='timelineComponent'>
        <div v-if="loadingData">
            <h2>Loading data <i class="fa fa-circle-o-notch fa-spin fa-fw"></i></h2>
        </div>
        <div v-else-if="failedToLoadData">
            <h2 class='text-danger'><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Failed to load timeline
                data.</h2>
        </div>
        <div v-else>
          <div class="compact-timeline" v-if="compactView">
            <div class="event active" v-tooltip.top-center="firstStatus" ></div>
            <template v-for="event in timeline" >
              <div  v-if="getStatusText(event.state).length > 0" class="event" :class="event.active ? 'active' : '' "  :key="event.state" v-tooltip.top-center="getStatusText(event.state)"></div>
            </template>
          </div>
          <div class="timeline" v-else>
            <div class="event active">
              <div class="left">
                <div class="content">{{ purchaseDate }}</div>
              </div>
              <div class="right">
                <div class="content">
                  {{ firstStatus }}
                  <div class="mobileTimelineDate text-muted" style="font-weight:normal">{{ purchaseDate }}</div>
                </div>
                <!--<a class="toggle" href="#">Show Detail</a>-->
              </div>
            </div>
            <template v-for="event in timeline" >
              <div v-if="getStatusText(event.state).length > 0" class="event" :class="event.active ? 'active' : '' " :key="event.state">
                <div class="left">
                  <div class="content" v-if="event.active">{{ event.date }}</div>
                </div>
                <div class="right">
                  <div class="content">
                    {{ getStatusText(event.state) }}
                    <div class="mobileTimelineDate text-muted" style="font-weight:normal">{{ event.date}}</div>
                  </div>
                  <!--<a class="toggle" href="#">Show Detail</a>-->
                </div>
              </div>
            </template>
          </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import {kitStatusesDetails} from '@/enums/kitItemStatus'
import dateMixin from '@/mixins/date'
import moment from 'moment'

export default {
  name: 'KitTimeline',
  mixins: [dateMixin],
  mounted: function () {
    this.loadingDate = true
    this.$store.dispatch('getKitTimeline', this.kit.id).then(ok => {
      this.timelineData = this.$store.state.GET_KIT_TIMELINE_RESPONSE
    }).catch((error) => {
      this.loadingDate = false
      this.failedToLoadData = true
      console.log(error)
    })
  },
  props: ['kit', 'overrideStatuses', 'compactView', 'baseStatus'],
  data () {
    return {
      loadingData: false,
      failedToLoadData: false,
      statusTextDefault: {
        REQUESTED: 'Preparing your order',
        DISPATCHED_BY_MICROBA: 'Your kit has been dispatched',
        RECEIVED_BY_LAB: 'Sample received by lab',
        ACCESSIONING: 'Lab is processing your sample',
        RESULTS_AVAILABLE: 'Your report is available',
        MICROBIOME_COACH_SESSION_COMPLETED: 'Book a Microbiome Coach session'
      },
      timelineData: []
    }
  },
  computed: {
    firstStatus () {
      return this.baseStatus || 'Kit Purchased'
    },
    states () {
      return Object.keys(this.statusText)
    },
    statusText () {
      return this.overrideStatuses || this.statusTextDefault
    },
    timelineOrderByDate: function () {
      return _.chain(this.timelineData)
              .sortBy(this.timelineData, (x) => x.date)
              .groupBy('eventType')
              .value()
    },
    purchaseDate: function () {
      var dateKey = null
      if (this.kit.activatedDate) {
        dateKey = this.kit.activatedDate
      } else if (this.kit.redeemedDate) {
        dateKey = this.kit.redeemedDate
      } else {
        // If all date keys are empty - fall back to todays as a default.
        dateKey = new Date()
      }
      const theDate = moment(dateKey)
      return theDate.format('MMMM Do Y')
    },
    timeline: function () {
      let data = []
      this.states.forEach((state, stateIndex) => {
        let active = false
        let date = 'Unknown'
        if (this.getStatusDate(state)) {
          active = true
        }
        const event = {
          state: state,
          active: active,
          date: this.getStatusDate(state) || date
        }

        if (!active) {
          this.states.filter((state, index) => index > stateIndex).forEach((state) => {
            if (active === false && this.timelineOrderByDate[state] && this.timelineOrderByDate[state].length > 0) {
              active = true
            }
          })
        }
        event.active = active
        data.push(event)
      })
      return data
    }
  },
  methods: {
    getStatusText (status) {
      if (this.statusText[status]) {
        return this.statusText[status]
      }
      return ''
    },
    getStatusDate (status) {
      if (this.timelineOrderByDate[status]) {
        const theDate = moment(this.timelineOrderByDate[status][0]['dateTime'])
        return theDate.format('MMMM Do Y')
      }
      return null
    },
    getDetails (status = null) {
      return kitStatusesDetails[status] || 'Status details missing.'
    }
  }
}
</script>


<style lang="scss" scoped>
  .compact-timeline {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    width: 280px;
    margin-left: -20px;

    .event {
      width: 25px;
    }

    .event::after {
      content: '';
      position: absolute;
      width: 25px;
      height: 25px;
      background-color: white;
      border: 4px solid #bdbfcc;
      border-radius: 50%;
      top: 0;
    }

    .event.active::after {
      font-family: 'Font Awesome 5 Free';
      content: "\f00c";
      font-weight: 900;
      color: #fff;
      text-align: center;
      line-height: 20px;
      position: absolute;
      width: 25px;
      height: 25px;
      background-color: #7dd3a3;
      border: 4px solid #7dd3a3;
      border-radius: 50%;
      top: 0;
    }
  }

  .timeline{
    width:600px;
    position:relative;
    /* The actual timeline (the vertical ruler) */
  }
  .timeline.active::after {
    content: '';
    position: absolute;
    width: 6px;
    background-color: #7dd3a3;
    top: 0;
    bottom: 0;
    left: 31%;
    margin-left: -3px;
  }
  .timeline::after {
    content: '';
    position: absolute;
    width: 6px;
    background-color: #8ed29f;
    top: 0px;
    bottom: 0;
    left: 31%;
    margin-left: -3px;
  }
  .event {
    position:relative;
    display: flex;
    background: #f2f2f2;
    margin-bottom:5px;
  }
  .event .left{
    /*background: green;*/
    width:31%;
    padding:20px 5px;
  }
  .event .left{
    background: #fff;
  }

  .active{
    .left {
      background: #f2f2f2 !important;
    }
    .right{
      background: #c9eddb;
    }
  }

  .active .event .left{
    background: #f2f2f2 !important;
  }

  .event .left .content{
    padding-left:15px;

  }

  .event .right{
    width:70%;
    padding:20px 5px;
  }

  .active .event .right{
    background: #c9eddb;
  }

  .event .right .content{
    padding-left:30px;
    font-weight: 500;
  }

  .event .right .content span{
    display:block;
    margin-top:10px;
    font-weight: 100;
  }

  .event .right .toggle{
    position: absolute;
    right:15px;
    top:20px;
    text-decoration: none;
    color: #4a5667;
  }

  /* The circles on the timeline */
  .event::after {
    content: '';
    position: absolute;
    width: 25px;
    height: 25px;
    left:	29%;
    background-color: white;
    border: 4px solid #bdbfcc;
    top: 15px;
    border-radius: 50%;
    z-index: 1;
  }
  .event.active::after {
    font-family: 'Font Awesome 5 Free';
    content: "\f00c";
    font-weight: 900;
    color: #fff;
    text-align: center;
    line-height: 20px;
    position: absolute;
    width: 25px;
    height: 25px;
    left:	29%;
    background-color: #7dd3a3;
    border: 4px solid #7dd3a3;
    top: 15px;
    border-radius: 50%;
    z-index: 1;
  }

  .mobileTimelineDate{
    display:none;
  }

  @media (max-width: 750px){
    .timeline{
      width:300px;
      position:relative;
      /* The actual timeline (the vertical ruler) */
    }

    .event .left{
      display:none
    }

    .event .right{
      width:100%;
      padding:20px 5px;
    }


    .event::after {
      content: '';
      position: absolute;
      width: 25px;
      height: 25px;
      left:	29%;
      background-color: white;
      border: 4px solid #bdbfcc;
      top: 15px;
      border-radius: 50%;
      z-index: 1;
    }
    .event::after {
      left:	-5%;
    }
    .event.active::after {
      left:	-5%;
    }
    .timeline.active::after {
      left: -1%;
    }
    .timeline::after {
      left: -1%;
    }

    .mobileTimelineDate{
      display:block;
    }
  }

  @media (max-width:1024px) {
    .compact-timeline{
      width: 100%;
    }
  }
  @media (min-width:1024px) {
    .compact-timeline{
      width:280px;
    }
  }

</style>




// WEBPACK FOOTER //
// src/components/elements/KitTimeline.vue